module.exports = __webpack_public_path__ + "assets/img/26_748.b21ef57b.jpg";